import type { Component } from "solid-js"
import { Button } from "@/designSystem/components/button"
import { Icon } from "@/designSystem/components/icon"
import { useI18nContext } from "@/i18n/i18n-solid"
import {
  headerClass,
  iconClass,
  messageClass,
  promptClass,
} from "./subscription-item-private-content-prompt.css"

interface PrivateContentPromptProps {
  reason?: "not_logged_in" | "not_subscribed" | "wrong_tier" | null
  requiredTiers: Array<{
    id: string
    name: string
    monthlyPriceCents: number
    annualPriceCents: number | null
  }>
  onUpgradeClick: () => void
}

export const PrivateContentPrompt: Component<
  PrivateContentPromptProps
> = props => {
  const { LL } = useI18nContext()

  return (
    <div class={promptClass}>
      <div class={headerClass}>
        <div class={iconClass}>
          <Icon name="lock" size="24" color="sand700" />
        </div>
        <p class={messageClass}>{LL().auth.getUpdates()}</p>
      </div>
      <Button hue="emerald" onClick={() => props.onUpgradeClick()}>
        {LL().privatePost.subscribeCta()}
      </Button>
    </div>
  )
}
